// Тестовый контур: https://test.nok.mossport.ru (сборка `npm run build:test`, ветка develop).
export const environment = {
    production: false,
    apiUrl: '/api',
    portalUrl: 'https://test.id.mossport.ru/',
    keycloak: {
        authority: 'https://test.kk.mossport.ru/realms/sport',
        clientId: 'nok-spa',
        scope: 'openid profile email',
    },
};
